import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cn-report-popup',
  templateUrl: './cn-report-popup.component.html',
  styleUrls: ['./cn-report-popup.component.scss']
})
export class CnReportPopupComponent {
  isOpen = false;

  constructor(private router: Router) {}

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }

  openReport(type: string) {
    const tree = this.router.createUrlTree(['/challenges', `report-${type}`]);
    const url = this.router.serializeUrl(tree);
    window.open(url, '_blank');
    this.closeModal();
  }
}
